"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cannotUsePrivateProjectRulesAgreement = exports.cannotUpdateProjectRulesAgreementInUse = exports.cannotDeleteProjectRulesAgreementInUse = exports.missingPRASignature = exports.signatureIsRequired = exports.obligationsDisabledNoPRA = exports.assetsDisabledNoPRA = exports.notPermitted = exports.obligationsDisabled = exports.assetsDisabled = exports.missingRejectMessage = exports.userIsAlreadyInProject = exports.cannotBeBlank = exports.alreadyEnrolled = exports.notEnrolled = exports.notLoggedIn = exports.invalidEmailOrPassword = exports.invalidPassword = exports.missingRequiredField = exports.invalidURL = exports.invalidEmail = exports.invalidCode = exports.noUserWithThatEmail = exports.emailNotUnique = exports.missingEnvVar = exports.expired = exports.notFound = exports.featureDisabled = exports.missingReactContext = exports.typeError = void 0;
const minPasswordLength_1 = require("../constants/minPasswordLength");
/**
 * Throw an error with an optional http status code.
 *
 * @param message - The error message.
 * @param status - The HTTP status code. Defaults to 400.
 */
function throwError(message, status = 400) {
    throw Object.assign(new Error(message), { status });
}
function typeError(expectedType, valueName = 'value') {
    throwError(`Type error. Expected ${valueName} to be of type ${expectedType}.`);
}
exports.typeError = typeError;
function missingReactContext(providerName, hookName) {
    throwError(`${hookName} must be called beneath ${providerName} in the render tree.`);
}
exports.missingReactContext = missingReactContext;
function featureDisabled(featureName) {
    throwError(`Feature ${featureName} is disabled.`);
}
exports.featureDisabled = featureDisabled;
function notFound(subject) {
    throwError(`${subject} not found.`, 404);
}
exports.notFound = notFound;
function expired(subject) {
    throwError(`This ${subject} is expired.`);
}
exports.expired = expired;
function missingEnvVar(name) {
    throwError(`Missing required env var: ${name}`);
}
exports.missingEnvVar = missingEnvVar;
function emailNotUnique() {
    throwError('A user already exists with that email.');
}
exports.emailNotUnique = emailNotUnique;
function noUserWithThatEmail() {
    throwError('No user exists with that email address.');
}
exports.noUserWithThatEmail = noUserWithThatEmail;
function invalidCode() {
    throwError('Invalid code.');
}
exports.invalidCode = invalidCode;
function invalidEmail() {
    throwError('Invalid email.');
}
exports.invalidEmail = invalidEmail;
function invalidURL() {
    throwError('Invalid URL.');
}
exports.invalidURL = invalidURL;
function missingRequiredField(fieldName) {
    throwError(`${fieldName} is required.`);
}
exports.missingRequiredField = missingRequiredField;
function invalidPassword() {
    throwError(`Invalid password. Password must be at least ${minPasswordLength_1.minPasswordLength} characters.`);
}
exports.invalidPassword = invalidPassword;
function invalidEmailOrPassword() {
    throwError(`Invalid email or password.`);
}
exports.invalidEmailOrPassword = invalidEmailOrPassword;
function notLoggedIn() {
    throwError('You must be logged in to do that.');
}
exports.notLoggedIn = notLoggedIn;
function notEnrolled() {
    throwError('You must finish registering before you can do that.');
}
exports.notEnrolled = notEnrolled;
function alreadyEnrolled() {
    throwError('You are already enrolled.');
}
exports.alreadyEnrolled = alreadyEnrolled;
function cannotBeBlank(fieldName) {
    throwError(`${fieldName} cannot be blank.`);
}
exports.cannotBeBlank = cannotBeBlank;
function userIsAlreadyInProject(userEmail) {
    throwError(`The user ${userEmail} is already in this project.`);
}
exports.userIsAlreadyInProject = userIsAlreadyInProject;
function missingRejectMessage() {
    throwError(`You cannot reject an asset without providing a reason.`);
}
exports.missingRejectMessage = missingRejectMessage;
function assetsDisabled() {
    throwError('Assets are disabled for this project.');
}
exports.assetsDisabled = assetsDisabled;
function obligationsDisabled() {
    throwError('Obligations are disabled for this project.');
}
exports.obligationsDisabled = obligationsDisabled;
function notPermitted(action) {
    throwError(`You do not have permission to ${action}.`);
}
exports.notPermitted = notPermitted;
function assetsDisabledNoPRA() {
    throwError('Assets are disabled until a PRA is added.');
}
exports.assetsDisabledNoPRA = assetsDisabledNoPRA;
function obligationsDisabledNoPRA() {
    throwError('Obligations are disabled until a PRA is added.');
}
exports.obligationsDisabledNoPRA = obligationsDisabledNoPRA;
function signatureIsRequired() {
    throwError(`Your signature is required.`);
}
exports.signatureIsRequired = signatureIsRequired;
function missingPRASignature() {
    throwError('You must sign the project rules agreement (PRA) before you can do that.');
}
exports.missingPRASignature = missingPRASignature;
function cannotDeleteProjectRulesAgreementInUse() {
    throwError('Cannot delete a project rules agreement that is assigned to a project.');
}
exports.cannotDeleteProjectRulesAgreementInUse = cannotDeleteProjectRulesAgreementInUse;
function cannotUpdateProjectRulesAgreementInUse() {
    throwError('Cannot update a project rules agreement that is assigned to a project.');
}
exports.cannotUpdateProjectRulesAgreementInUse = cannotUpdateProjectRulesAgreementInUse;
function cannotUsePrivateProjectRulesAgreement() {
    throwError('You do not have permission to use that project rules agreement.');
}
exports.cannotUsePrivateProjectRulesAgreement = cannotUsePrivateProjectRulesAgreement;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzRUFBbUU7QUFFbkU7Ozs7O0dBS0c7QUFDSCxTQUFTLFVBQVUsQ0FBQyxPQUFlLEVBQUUsTUFBTSxHQUFHLEdBQUc7SUFDL0MsTUFBTSxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsQ0FBQztBQUN0RCxDQUFDO0FBRUQsU0FBZ0IsU0FBUyxDQUFDLFlBQW9CLEVBQUUsU0FBUyxHQUFHLE9BQU87SUFDakUsVUFBVSxDQUNSLHdCQUF3QixTQUFTLGtCQUFrQixZQUFZLEdBQUcsQ0FDbkUsQ0FBQztBQUNKLENBQUM7QUFKRCw4QkFJQztBQUVELFNBQWdCLG1CQUFtQixDQUNqQyxZQUFvQixFQUNwQixRQUFnQjtJQUVoQixVQUFVLENBQ1IsR0FBRyxRQUFRLDJCQUEyQixZQUFZLHNCQUFzQixDQUN6RSxDQUFDO0FBQ0osQ0FBQztBQVBELGtEQU9DO0FBRUQsU0FBZ0IsZUFBZSxDQUFDLFdBQW1CO0lBQ2pELFVBQVUsQ0FBQyxXQUFXLFdBQVcsZUFBZSxDQUFDLENBQUM7QUFDcEQsQ0FBQztBQUZELDBDQUVDO0FBRUQsU0FBZ0IsUUFBUSxDQUFDLE9BQWU7SUFDdEMsVUFBVSxDQUFDLEdBQUcsT0FBTyxhQUFhLEVBQUUsR0FBRyxDQUFDLENBQUM7QUFDM0MsQ0FBQztBQUZELDRCQUVDO0FBRUQsU0FBZ0IsT0FBTyxDQUFDLE9BQWU7SUFDckMsVUFBVSxDQUFDLFFBQVEsT0FBTyxjQUFjLENBQUMsQ0FBQztBQUM1QyxDQUFDO0FBRkQsMEJBRUM7QUFFRCxTQUFnQixhQUFhLENBQUMsSUFBWTtJQUN4QyxVQUFVLENBQUMsNkJBQTZCLElBQUksRUFBRSxDQUFDLENBQUM7QUFDbEQsQ0FBQztBQUZELHNDQUVDO0FBRUQsU0FBZ0IsY0FBYztJQUM1QixVQUFVLENBQUMsd0NBQXdDLENBQUMsQ0FBQztBQUN2RCxDQUFDO0FBRkQsd0NBRUM7QUFFRCxTQUFnQixtQkFBbUI7SUFDakMsVUFBVSxDQUFDLHlDQUF5QyxDQUFDLENBQUM7QUFDeEQsQ0FBQztBQUZELGtEQUVDO0FBRUQsU0FBZ0IsV0FBVztJQUN6QixVQUFVLENBQUMsZUFBZSxDQUFDLENBQUM7QUFDOUIsQ0FBQztBQUZELGtDQUVDO0FBRUQsU0FBZ0IsWUFBWTtJQUMxQixVQUFVLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztBQUMvQixDQUFDO0FBRkQsb0NBRUM7QUFFRCxTQUFnQixVQUFVO0lBQ3hCLFVBQVUsQ0FBQyxjQUFjLENBQUMsQ0FBQztBQUM3QixDQUFDO0FBRkQsZ0NBRUM7QUFFRCxTQUFnQixvQkFBb0IsQ0FBQyxTQUFpQjtJQUNwRCxVQUFVLENBQUMsR0FBRyxTQUFTLGVBQWUsQ0FBQyxDQUFDO0FBQzFDLENBQUM7QUFGRCxvREFFQztBQUVELFNBQWdCLGVBQWU7SUFDN0IsVUFBVSxDQUNSLCtDQUErQyxxQ0FBaUIsY0FBYyxDQUMvRSxDQUFDO0FBQ0osQ0FBQztBQUpELDBDQUlDO0FBRUQsU0FBZ0Isc0JBQXNCO0lBQ3BDLFVBQVUsQ0FBQyw0QkFBNEIsQ0FBQyxDQUFDO0FBQzNDLENBQUM7QUFGRCx3REFFQztBQUVELFNBQWdCLFdBQVc7SUFDekIsVUFBVSxDQUFDLG1DQUFtQyxDQUFDLENBQUM7QUFDbEQsQ0FBQztBQUZELGtDQUVDO0FBRUQsU0FBZ0IsV0FBVztJQUN6QixVQUFVLENBQUMscURBQXFELENBQUMsQ0FBQztBQUNwRSxDQUFDO0FBRkQsa0NBRUM7QUFFRCxTQUFnQixlQUFlO0lBQzdCLFVBQVUsQ0FBQywyQkFBMkIsQ0FBQyxDQUFDO0FBQzFDLENBQUM7QUFGRCwwQ0FFQztBQUVELFNBQWdCLGFBQWEsQ0FBQyxTQUFpQjtJQUM3QyxVQUFVLENBQUMsR0FBRyxTQUFTLG1CQUFtQixDQUFDLENBQUM7QUFDOUMsQ0FBQztBQUZELHNDQUVDO0FBRUQsU0FBZ0Isc0JBQXNCLENBQUMsU0FBaUI7SUFDdEQsVUFBVSxDQUFDLFlBQVksU0FBUyw4QkFBOEIsQ0FBQyxDQUFDO0FBQ2xFLENBQUM7QUFGRCx3REFFQztBQUVELFNBQWdCLG9CQUFvQjtJQUNsQyxVQUFVLENBQUMsd0RBQXdELENBQUMsQ0FBQztBQUN2RSxDQUFDO0FBRkQsb0RBRUM7QUFFRCxTQUFnQixjQUFjO0lBQzVCLFVBQVUsQ0FBQyx1Q0FBdUMsQ0FBQyxDQUFDO0FBQ3RELENBQUM7QUFGRCx3Q0FFQztBQUVELFNBQWdCLG1CQUFtQjtJQUNqQyxVQUFVLENBQUMsNENBQTRDLENBQUMsQ0FBQztBQUMzRCxDQUFDO0FBRkQsa0RBRUM7QUFFRCxTQUFnQixZQUFZLENBQUMsTUFBYztJQUN6QyxVQUFVLENBQUMsaUNBQWlDLE1BQU0sR0FBRyxDQUFDLENBQUM7QUFDekQsQ0FBQztBQUZELG9DQUVDO0FBRUQsU0FBZ0IsbUJBQW1CO0lBQ2pDLFVBQVUsQ0FBQywyQ0FBMkMsQ0FBQyxDQUFDO0FBQzFELENBQUM7QUFGRCxrREFFQztBQUVELFNBQWdCLHdCQUF3QjtJQUN0QyxVQUFVLENBQUMsZ0RBQWdELENBQUMsQ0FBQztBQUMvRCxDQUFDO0FBRkQsNERBRUM7QUFFRCxTQUFnQixtQkFBbUI7SUFDakMsVUFBVSxDQUFDLDZCQUE2QixDQUFDLENBQUM7QUFDNUMsQ0FBQztBQUZELGtEQUVDO0FBRUQsU0FBZ0IsbUJBQW1CO0lBQ2pDLFVBQVUsQ0FDUix5RUFBeUUsQ0FDMUUsQ0FBQztBQUNKLENBQUM7QUFKRCxrREFJQztBQUVELFNBQWdCLHNDQUFzQztJQUNwRCxVQUFVLENBQ1Isd0VBQXdFLENBQ3pFLENBQUM7QUFDSixDQUFDO0FBSkQsd0ZBSUM7QUFFRCxTQUFnQixzQ0FBc0M7SUFDcEQsVUFBVSxDQUNSLHdFQUF3RSxDQUN6RSxDQUFDO0FBQ0osQ0FBQztBQUpELHdGQUlDO0FBRUQsU0FBZ0IscUNBQXFDO0lBQ25ELFVBQVUsQ0FBQyxpRUFBaUUsQ0FBQyxDQUFDO0FBQ2hGLENBQUM7QUFGRCxzRkFFQyJ9